// Generated by purs version 0.15.15
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Literals_Undefined from "../Literals.Undefined/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
import * as Untagged_Castable from "../Untagged.Castable/index.js";
import * as Untagged_TypeCheck from "../Untagged.TypeCheck/index.js";
var cast = /* #__PURE__ */ Untagged_Castable.cast();
var withOneOf = function (dictHasRuntimeType) {
    var hasRuntimeType = Untagged_TypeCheck.hasRuntimeType(dictHasRuntimeType);
    return function (f) {
        return function (g) {
            return function (o) {
                var isTypeA = hasRuntimeType(Type_Proxy["Proxy"].value);
                var $42 = isTypeA(Foreign.unsafeToForeign(o));
                if ($42) {
                    return f(o);
                };
                return g(o);
            };
        };
    };
};
var withOneOf1 = /* #__PURE__ */ withOneOf(Untagged_TypeCheck.hasRuntimeTypeUndefined);
var toEither1 = function (dictHasRuntimeType) {
    return withOneOf(dictHasRuntimeType)(Data_Either.Left.create)(Data_Either.Right.create);
};
var reduceA = {
    reduce: Data_Function.apply
};
var reduce = function (dict) {
    return dict.reduce;
};
var reduceOneOf = function (dictReducible) {
    var reduce1 = reduce(dictReducible);
    return function (dictHasRuntimeType) {
        var toEither11 = toEither1(dictHasRuntimeType);
        return {
            reduce: function (v) {
                return function (o) {
                    var v1 = toEither11(o);
                    if (v1 instanceof Data_Either.Left) {
                        return v.value0(v1.value0);
                    };
                    if (v1 instanceof Data_Either.Right) {
                        return reduce1(v.value1)(v1.value0);
                    };
                    throw new Error("Failed pattern match at Untagged.Union (line 142, column 5 - line 144, column 29): " + [ v1.constructor.name ]);
                };
            }
        };
    };
};
var oneOfEq = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return function (dictEq1) {
        var eq1 = Data_Eq.eq(dictEq1);
        return function (dictHasRuntimeType) {
            var toEither11 = toEither1(dictHasRuntimeType);
            return {
                eq: function (o) {
                    return function (o$prime) {
                        var v = toEither11(o$prime);
                        var v1 = toEither11(o);
                        if (v1 instanceof Data_Either.Left && v instanceof Data_Either.Left) {
                            return eq(v1.value0)(v.value0);
                        };
                        if (v1 instanceof Data_Either.Right && v instanceof Data_Either.Right) {
                            return eq1(v1.value0)(v.value0);
                        };
                        return false;
                    };
                }
            };
        };
    };
};
var inOneOfTail = function () {
    return {};
};
var inOneOfLast = {};
var inOneOfHead = {};
var hasRuntimeTypeOneOf = function (dictHasRuntimeType) {
    var hasRuntimeType = Untagged_TypeCheck.hasRuntimeType(dictHasRuntimeType);
    return function (dictHasRuntimeType1) {
        var hasRuntimeType1 = Untagged_TypeCheck.hasRuntimeType(dictHasRuntimeType1);
        return {
            hasRuntimeType: function (v) {
                return function (x) {
                    return hasRuntimeType(Type_Proxy["Proxy"].value)(x) || hasRuntimeType1(Type_Proxy["Proxy"].value)(x);
                };
            }
        };
    };
};
var getRight$prime = function (dictHasRuntimeType) {
    var hasRuntimeType = Untagged_TypeCheck.hasRuntimeType(dictHasRuntimeType);
    return function (o) {
        var isTypeA = hasRuntimeType(Type_Proxy["Proxy"].value);
        var $57 = isTypeA(Foreign.unsafeToForeign(o));
        if ($57) {
            return Data_Maybe.Nothing.value;
        };
        return new Data_Maybe.Just(o);
    };
};
var uorToMaybe = /* #__PURE__ */ getRight$prime(Untagged_TypeCheck.hasRuntimeTypeUndefined);
var getRight = function (dictHasRuntimeType) {
    var hasRuntimeType = Untagged_TypeCheck.hasRuntimeType(dictHasRuntimeType);
    return function (o) {
        var isTypeB = hasRuntimeType(Type_Proxy["Proxy"].value);
        var $58 = isTypeB(Foreign.unsafeToForeign(o));
        if ($58) {
            return new Data_Maybe.Just(o);
        };
        return Data_Maybe.Nothing.value;
    };
};
var getLeft$prime = function (dictHasRuntimeType) {
    var hasRuntimeType = Untagged_TypeCheck.hasRuntimeType(dictHasRuntimeType);
    return function (o) {
        var isTypeB = hasRuntimeType(Type_Proxy["Proxy"].value);
        var $59 = isTypeB(Foreign.unsafeToForeign(o));
        if ($59) {
            return Data_Maybe.Nothing.value;
        };
        return new Data_Maybe.Just(o);
    };
};
var getLeft = function (dictHasRuntimeType) {
    var hasRuntimeType = Untagged_TypeCheck.hasRuntimeType(dictHasRuntimeType);
    return function (o) {
        var isTypeA = hasRuntimeType(Type_Proxy["Proxy"].value);
        var $60 = isTypeA(Foreign.unsafeToForeign(o));
        if ($60) {
            return new Data_Maybe.Just(o);
        };
        return Data_Maybe.Nothing.value;
    };
};
var fromUndefinedOr = function (a) {
    var $64 = Data_Maybe.fromMaybe(a);
    return function ($65) {
        return $64(uorToMaybe($65));
    };
};
var fromOneOf = function () {
    return function (dictHasRuntimeType) {
        var hasRuntimeType = Untagged_TypeCheck.hasRuntimeType(dictHasRuntimeType);
        return function (f) {
            var $61 = hasRuntimeType(Type_Proxy["Proxy"].value)(Foreign.unsafeToForeign(f));
            if ($61) {
                return new Data_Maybe.Just(f);
            };
            return Data_Maybe.Nothing.value;
        };
    };
};
var defined = Unsafe_Coerce.unsafeCoerce;
var coercibleOneOf = function () {
    return {};
};
var maybeToUor = function (v) {
    if (v instanceof Data_Maybe.Just) {
        return v.value0;
    };
    if (v instanceof Data_Maybe.Nothing) {
        return cast(Literals_Undefined["undefined"]);
    };
    throw new Error("Failed pattern match at Untagged.Union (line 121, column 1 - line 121, column 49): " + [ v.constructor.name ]);
};
var withUor$prime = function (f) {
    return function (o) {
        return withOneOf1(Data_Function["const"](cast(Literals_Undefined["undefined"])))(f)(o);
    };
};
var withUor = function (f) {
    return withUor$prime(function ($66) {
        return f($66);
    });
};
var asOneOf = function () {
    return cast;
};
export {
    asOneOf,
    fromOneOf,
    toEither1,
    getLeft,
    getLeft$prime,
    getRight,
    getRight$prime,
    defined,
    uorToMaybe,
    maybeToUor,
    withUor,
    fromUndefinedOr,
    reduce,
    oneOfEq,
    hasRuntimeTypeOneOf,
    inOneOfHead,
    inOneOfLast,
    inOneOfTail,
    coercibleOneOf,
    reduceOneOf,
    reduceA
};
//# sourceMappingURL=index.js.map
